import React, { useEffect, useState, useMemo, useContext } from 'react';
// @ts-ignore
import { USBLink } from '@usb-shield/components-react';
import Loader from '../../components/utilities/Loader';
import moment from 'moment';
import { getInboxRequirements, getDefaultFilters, getAllReadByUsersList } from './utils';
import InboxFilters from './InboxFilters';
import InboxTable from './InboxTable';
import ReadUserList from './ReadUserList';
import { USBIconDownload, USBIconPeople } from '@usb-shield/react-icons';
import './inbox.scss';
import USBBreadcrumb from '@usb-shield/components-react/dist/cjs/breadcrumb';
import { FeatureFlagsContext } from '../../components/Hooks/useFeatureFlags';
import { ExportToExcel } from '../../components/utilities/ExportToExcel';

function Inbox() {
  const [error, setError] = useState(null);
  const [status, setStatus] = useState({ loading: true, error: null });
  const [requirements, setRequirements] = useState(null);
  const [filters, setFilters] = useState(getDefaultFilters());
  const [opneModel, setOpenModel] = useState(false)
  const [requirementID, setRequirementId] = useState('')
  const { featureDetails } = useContext(FeatureFlagsContext);
  const [readUserList, setReadUserList] = useState(null);
  async function fetchData() {
    await getInboxRequirements({ setRequirements, setStatus });
    await setStatus({ loading: false, error: status.error });
  }

  useEffect(() => {
    fetchData();
  }, []);


  useEffect(() => {
    if (featureDetails?.length > 0) {
      if (!featureDetails?.includes("feature_inbox_visible")) {
        window.location.href = "/Redirect";
      }
    }
  }, [featureDetails])
  const filteredRequirements = useMemo(() => {
    // console.log('Filtering requirements with filters:', filters);
    if (["investor reports", "true up review"].includes(filters?.['category']?.value?.split('*')[1]?.toLowerCase())) {

      return requirements?.filter((item) => item.requirementName === filters?.['category']?.label)
    }
    return requirements?.filter((item) =>
      Object.entries(filters).every(([key, obj]) => {
        const keys = key.split('.');
        const itemValue = keys.reduce((acc, current) => acc && acc[current], item);
        if (key === 'lastUpdateDate') {
          const formattedItemValue = itemValue
            ? moment.utc(itemValue.split('T')[0], 'YYYY-MM-DD').format('MM/DD/YYYY')
            : '';
          return formattedItemValue === obj?.value;
        }
        return itemValue === obj?.value;
      })
    );
  }, [filters, requirements]);

  const requirementIdList = useMemo(() => {
    return filteredRequirements?.filter((item) => item.status === 'Read')?.map((item) => item.id);
  }, [filteredRequirements]);

  const formatDate = (date) => {
    if (date === null || date === undefined || date === '') {
      return '-'
    }
    const parsedDate = moment.utc(date.split('T')[0], 'YYYY-MM-DD').format('MM-DD-YYYY');
    return parsedDate.length === 10 || parsedDate === "Invalid Date" ? parsedDate : '-';
  };

  const columns = [
    {
      label: 'Received Date',
      accessor: 'lastUpdateDate',
      sortable: true,

      cell: (row) => {
        return <>{formatDate(row?.lastUpdateDate)}</>;
      },
      style: { width: '12%' },
    },
    {
      label: 'As Of Date',
      accessor: 'notificationDate',
      sortable: true,

      cell: (row) => {
        return <>{formatDate(row?.notificationDate)}</>;
      },
      style: { width: '12%' },
    },
    {
      label: 'Deal Name',
      accessor: 'metadata.dealName',
      sortable: true,
      style: { width: '16%' },
    },
    {
      label: 'Legal Entity',
      accessor: 'metadata.reportingEntity',
      sortable: true,
      style: { width: '16%' },
    },
    {
      label: 'Document Type',
      accessor: 'category',
      style: { width: '16%' },
      cell: (row) => {
        return <>{["investor reports", "true up review"].includes((row.category + "").toLowerCase()) ? row.requirementName : row.category.charAt(0).toUpperCase() + row.category.slice(1)}</>;
      },
    },
    {
      label: 'Status',
      accessor: 'status',
      sortable: true,
      style: { width: '10%' },

    },

    ...sessionStorage.getItem('userrole') === 'employee' ? [{
      label: 'Read By',
      accessor: 'read',
      disableRowClick: true,
      style: { width: '10%' },
      cell: (row) => {
        function UserBoxRender(params) {
          setOpenModel(true)
          setRequirementId(row.id)
        }
        const disabledButton = row.status === 'New' ? true : false;
        return (
          <>
            <button
              className="table-action-icon"
              onClick={() => {
                UserBoxRender()
              }}
              disabled={disabledButton}
            >
              <USBIconPeople
                colorVariant={disabledButton ? 'grey60' : 'brand-primary'}
                title={`Click`}
                ariaHidden={true}
                id="add-icon"
                focusable={true}
                tabindex={-1}
                size={24}
                addClasses="action-preview-icon"
              />
            </button>
          </>
        )
      }
    }] : []
    ,
  ];
  function onCancel() {
    setOpenModel(false)
  }

  async function downloadInboxReporting() {
    const response = await getAllReadByUsersList(requirementIdList);
    const userListPerRequirement = response?.data;
    let tempdata = [];
    filteredRequirements.forEach((row) => {
      tempdata.push({
        RECEIVED_DATE: formatDate(row?.lastUpdateDate),
        AS_OF_DATE: formatDate(row?.notificationDate),
        DEAL_NAME: row.metadata.dealName,
        LEGAL_ENTITY: row.metadata.reportingEntity,
        DOCUMENT_TYPE: ["investor reports", "true up review"].includes((row.category + "").toLowerCase()) ? row.requirementName : row.category.charAt(0).toUpperCase() + row.category.slice(1),
        STATUS: row.status,
        READ_BY: userListPerRequirement.filter(item => item.requirementId === row.id)[0]?.inboxUserDetails.map((user) => `${user.firstName} ${user.lastName}`).join(', ') || 'N/A',
      });
    });
    ExportToExcel(
      Object.values(tempdata),
      'My_Inbox_Report',
    );
  }

  return (
    <section className="inbox-portfolio-container width-100">

      {featureDetails?.length > 0 && featureDetails?.includes("feature_inbox_visible") ?

        <section className="full-height">

          {sessionStorage.getItem('remote_user') ? (
            <div className="warning-panel-remote">
              You are impersonating the user:{' '}
              {JSON.parse(sessionStorage.getItem('remote_user')).firstName}{' '}
              {JSON.parse(sessionStorage.getItem('remote_user')).lastName}. To
              exit, click the 'Exit User' link above.
            </div>
          ) : (
            ''
          )}


          <USBBreadcrumb
            id="inbox"
            text="Inbox"
            breadcrumbs={[
              {
                id: 1,
                text: 'Inbox',
                href: '/Inbox',
              },
            ]}
          />


          <h1 className="heading-h1 p-t-md">Inbox</h1>
          <p className="secondary-text">
            You'll see documents for your customer listed below. Use the filters
            to view documents for a specific organization. Select a document to
            view or download files.
          </p>
          {/* component for popup on screen  */}
          <ReadUserList
            open={opneModel}
            id={requirementID}
            toggle={onCancel}
          />
          {sessionStorage.getItem('userrole')==='employee' && !sessionStorage.getItem('remote_user') && filteredRequirements?.length > 0 ? (
            <div className="report-download-inbox">
              <div className='inbox-report-container'>
                <div className="report-download-title">Download a Report</div>
                <button
                  id='downloadReportBtn'
                  type="button"
                  className="download-link"
                  onClick={downloadInboxReporting}
                >
                  Inbox (all reporting)
                </button>
              </div>

            </div>
          ) : (
            ''
          )}
          <InboxFilters
            requirements={requirements}
            filters={filters}
            setFilters={setFilters}
          ></InboxFilters>
          <div className='inbox-results-count'>
            {filteredRequirements?.length} result{filteredRequirements?.length !== 1 ? 's' : ''}
          </div>
          <InboxTable
            data={filteredRequirements || []}
            headers={columns}
            status={status}
            setStatus={setStatus}
            onRowClick={(row) => { window.location.href = `/Inbox/${row.id}?status=${row.status}`; }}
            searchProperties={{
              enable: true,
              keys: [
                'lastUpdateDate',
                'notificationDate',
                'metadata.dealName',
                'metadata.reportingEntity',
                'category',
                'requirementName',
                'status',
              ],
            }}
          ></InboxTable>
          {/* page loader */}
          {/* @ts-ignore */}
          {status.loading ? <Loader /> : null}
        </section>
        : ''}
    </section>
  );
}

export default Inbox;
